export default __webpack_public_path__ + "media/images/logo/contest/seino-f0420dde47687523649973bf124e1ec0.jpg";